<template lang="html">
  <div id="userRegistrationForm">
    <table class="registration-form">
      <tr>
        <td>ユーザー名:</td>
        <td><input type="text" name="username"
          placeholder="ユーザー名" v-model="additionalUser.name">
        </td>
      </tr>
      <tr>
        <td>パスワード:</td>
        <td><template v-if="isPasswordShown">
          <input type="text" name="password"
          placeholder="パスワード" v-model="additionalUser.password">
        </template>
        <template v-else>
          <input type="password" name="password"
          placeholder="パスワード" v-model="additionalUser.password">
        </template></td>
        <label><input type="checkbox" v-model="isPasswordShown" />パスワードを表示する</label>
      </tr>
      <tr>
        <td>氏名:</td>
        <td><input type="text" name="fullname"
            placeholder="氏名" v-model="additionalUser.fullname"></td>
      </tr>
      <tr>
        <td>フリガナ:</td>
        <td><input type="text" name="kana"
            placeholder="フリガナ" v-model="additionalUser.kana"></td>
      </tr>
      <tr>
        <td>mail:</td>
        <td><input type="text" name="mail_address"
          placeholder="mail_address" v-model="additionalUser.mail_address">
        </td>
      </tr>
      <tr>
        <td>ユーザー種別：</td>
        <td><select class="typeSelect" name="usertype" v-model="additionalUser.type">
          <option value="student" selected>生徒</option>
          <option value="teacher">教師</option>
          <option value="admin">管理者</option>
          <option value="viewer">閲覧者</option>
        </select></td>
      </tr>
      <tr>
        <td>ユーザー状態：</td>
        <td><select class="statusSelect" name="userstatus" v-model="additionalUser.status">
          <option value="normal" selected>通常</option>
          <option value="temporal">短期（単一）</option>
          <option value="trial">体験</option>
          <option value="temp/temp">短期（複数、元体験生）</option>
          <option value="temp/norm">短期及び長期</option>
        </select></td>
      </tr>
    </table>
    <button @click="registerUser">ユーザーを登録する</button>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  name: 'user-registration-form',
  data () {
    return {
      additionalUser: {
        name: '',
        password: '',
        fullname: '',
        type: '',
        kana: '',
        mail_address: '',
        status: 'normal'
      },
      isPasswordShown: false
    }
  },
  methods: {
    ...mapActions([
      'getTemporalStudentByFullname',
      'addUser',
      'changeUserInfo',
      'updateUserList'
    ]),
    registerUser () {
      if (!this.checkKana()) {
        alert('フリガナは全角カナのみで入力してください')
        return
      }
      if (this.additionalUser.type !== 'student') {
        this.addNewUser()
      } else {
        // 指定された氏名と同じ「一時的な」生徒がいるかどうかチェック
        this.getTemporalStudentByFullname(this.additionalUser.fullname)
        .then((res) => {
          // いた場合
          this.changeTempUser(res.data.temporal_student)
        })
        .catch((err) => {
          if (err.response.status === 404) {
            // いなかった場合
            this.addNewUser()
          }
        })
      }
    },
    addNewUser () {
      this.addUser({
        user_name: this.additionalUser.name,
        password: this.additionalUser.password,
        fullname: this.additionalUser.fullname,
        type: this.additionalUser.type,
        kana: this.additionalUser.kana,
        mail_address: this.additionalUser.mail_address,
        school_id: this.$store.state.userInfo.school_id,
        status: this.additionalUser.status
      }).then((res) => {
        alert('ユーザーの登録に成功しました id:' + res.data.id)
        this.updateUserList()
        this.additionalUser = {
          name: '',
          password: '',
          fullname: '',
          mail_address: '',
          type: '',
          kana: '',
          status: 'normal'
        }
      })
    },
    changeTempUser (id) {
      let userInfo = {
        new_user_name: this.additionalUser.name,
        new_password: this.additionalUser.password,
        new_fullname: this.additionalUser.fullname,
        new_kana: this.additionalUser.kana,
        new_mail_address: this.additionalUser.mail_address,
        new_status: this.additionalUser.status
      }
      this.changeUserInfo({
        id: id,
        user_info: userInfo
      })
      .then(() => {
        alert('ユーザーの登録に成功しました\n（同姓同名の短期ユーザの情報を変更しました）')
        this.updateUserList()
        this.additionalUser = {
          name: '',
          password: '',
          fullname: '',
          mail_address: '',
          type: '',
          kana: ''
        }
      })
      .catch(() => {

      })
    },
    checkKana () {
      if (!this.additionalUser.kana.match(/^[ァ-ヴ]+$/)) {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="css" scoped>
.itemEven {
  background-color: #ffffcc
}
.registration-form {
  margin: auto;
  text-align: left;
  border-collapse: separate;
  border-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// UserRegistrationForm.vue?433cf177